import client from "./client";

const getRefunds = () => client.get("/subsidiary/dashboard/refund/all");

export default { getRefunds };
